// __webpack_public_path__ = window.__DSF_MODULE_PATH__;

function setPath(v) {
  __webpack_public_path__ = v;
}
if (window.modulesPaths) {
  window.modulesPaths.push(setPath);
}
setPath(window.__DSF_MODULE_PATH__ || '');
